module.exports = __webpack_public_path__ + "8686440ad1e550e73ba84a9cec3f5d5c.svg";